import { createRetryFunction } from 'shared/utils/retry/retry-with-backoff'
import logger from 'shared/services/logger'
import {
  UnauthenticatedError,
  PermissionDeniedError,
  UserError,
} from '../errors'
import { isCannotSetCookieError } from '../auth/v2/refresh-session-client.helper'

// Export configuration for use in tests
export const RETRY_SESSION_FETCH_CONFIG = {
  maxRetries: 1,
  baseDelay: 250,
  maxDelay: 1000,
} as const

export const retrySessionFetch = createRetryFunction({
  // This retry session fetch is used in a number of places, including up and down the same line, so a single retry will actually mean multiple retries altogether
  // For that reason this has almost "exponential" implications -> a retry count of 3 times may result in 6 or 9+ retries, so keeping it at 1 should allow for a decent number of retries throughout the system
  maxRetries: RETRY_SESSION_FETCH_CONFIG.maxRetries,
  strategy: {
    type: 'exponential' as const,
    baseDelay: RETRY_SESSION_FETCH_CONFIG.baseDelay,
    maxDelay: RETRY_SESSION_FETCH_CONFIG.maxDelay,
  },
  // Fail immediately on auth errors and cookie errors - all other errors will be retried
  shouldFailImmediately: (error) =>
    error instanceof UserError ||
    error instanceof UnauthenticatedError ||
    error instanceof PermissionDeniedError ||
    isCannotSetCookieError(error), // Server component context where cookies can't be modified
  context: {
    operation: 'session-operation',
    feature: logger.Feature.Auth,
    logKey: 'session-retry-error',
  },
})
